import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'canvas-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DialogComponent {
  @Output() onClose = new EventEmitter();
  @Input() title = '';
  @Input() showTitleDivider = true;
  @Input() customTitle = false;
}
